import { defineComponent as r, createBlock as a, openBlock as l, unref as p, mergeProps as c, withCtx as i, createElementVNode as o } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const v = /* @__PURE__ */ r({
  name: "IconRepairSelf",
  __name: "IconRepairSelf",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const n = t;
    return (d, e) => (l(), a(p(m), c(n, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        o("path", {
          "fill-rule": "evenodd",
          d: "M14 7.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-1.5 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0",
          "clip-rule": "evenodd"
        }, null, -1),
        o("path", { d: "M8.25 12.5A4.25 4.25 0 0 0 4 16.75v2.5a.75.75 0 0 0 1.5 0v-2.5A2.75 2.75 0 0 1 8.25 14h6a.75.75 0 0 0 0-1.5h-6M19 12.813c1.165-.448 2-1.63 2-2.813 0-1.416-1.003-2.331-1.589-2.745C19.23 7.127 19 7.262 19 7.485v2.39a.3.3 0 0 1-.088.213l-.7.7a.3.3 0 0 1-.424 0l-.7-.7A.3.3 0 0 1 17 9.876v-2.39c0-.224-.23-.36-.411-.23C16.003 7.668 15 8.583 15 10c0 1.182.835 2.365 2 2.813V20a1 1 0 1 0 2 0v-7.187" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  v as default
};
